
        require('./index.scss');
        'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = require('model/service/user');

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-ad-red-packet');
var spFlag = $('body').attr('data-spFlag');
window.__adInit = false;

var _module = {
    init: function init() {
        if (window.__adInit) {
            return;
        }
        window.__adInit = true;
        var cityId = $mod.data('city_id');
        var pid = $mod.data('pid');
        var pidbind = $mod.data('pidbind');
        var actchannel = $mod.data('actchannel');

        _user2['default'].getInfo().then(function (data) {
            try {
                if (Dsp) {
                    var estateId = pid || '';
                    if (spFlag && spFlag !== '' && spFlag !== 'null') {
                        estateId = pidbind || '';
                    }
                    var params = {
                        estateId: estateId,
                        cityId: cityId || '',
                        exposure: true,
                        telephone: data.code == 200 && data.data ? data.data.mobile : '',
                        subplanChannel: '2',
                        activityChannel: actchannel,
                        source: spFlag ? 100 : 0 // spFlag表示不展示非本案的活动弹窗
                    };
                    console.log('Dsp: ', params);

                    new Dsp(params).init();
                }
            } catch (e) {
                console.log(e);
            }
        });
    }
};

exports['default'] = _module;;
    


// WEBPACK FOOTER //
// ./src/module/ad/red-packet/index.js